import { Box, Chip as BaseChip, styled, TextField as BaseTextField } from "@mui/material";

import { DEFAULT_TOPBAR_HEIGHT } from "fond/widgets/PageContent/constants";

export const SearchContainer = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const CollapsedSearchTrigger = styled(Box)`
  display: flex;
  align-items: center;
  width: 220px;
  height: 32px;
  padding: 0 12px;
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 0.8125rem;
  gap: 6px;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }
`;

export const Backdrop = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 29;
  background: rgba(0, 0, 0, 0.3);
`;

export const ExpandedSearchOverlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  background-color: ${({ theme }) => theme.palette.biarri.primary.midnight};
  padding: ${({ theme }) => theme.spacing(1, 2)};
  display: flex;
  align-items: center;
  height: ${DEFAULT_TOPBAR_HEIGHT}px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

export const ExpandedAutocompleteWrapper = styled(Box)`
  flex: 1;
  max-width: 700px;
  margin: 0 auto;
  position: relative;
`;

export const ExpandedTextField = styled(BaseTextField)`
  width: 100%;

  & .MuiOutlinedInput-root {
    height: 40px;
    font-size: 0.9375rem;
    padding: 0 12px;
    background: ${({ theme }) => theme.palette.common.white};
    border-radius: 8px;

    & fieldset {
      border: 0;
    }

    &.Mui-focused fieldset {
      border: 0;
    }

    & input {
      padding: 0;
    }
  }
`;

export const ScopeChip = styled(BaseChip)`
  height: 24px;
  font-size: 0.75rem;
  margin-right: ${({ theme }) => theme.spacing(0.5)};
  cursor: pointer;
  background-color: ${({ theme }) => theme.palette.info.light}26;
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.info.main};

  & .MuiChip-icon {
    color: ${({ theme }) => theme.palette.info.main};
  }

  & .MuiChip-label {
    padding: 0 8px;
  }

  & .MuiChip-deleteIcon {
    font-size: 16px;
    margin-right: 4px;
    color: ${({ theme }) => theme.palette.info.main};
  }
`;
